import { useState, useEffect } from 'react';
import { CloudOffline } from '@carbon/icons-react';

export function OfflineIndicator() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline) return null;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        backgroundColor: 'var(--neutral-light-2)',
        color: 'var(--neutral-medium-3)',
        padding: '8px 12px',
        borderRadius: '6px',
        fontWeight: 500,
        fontSize: '14px',
        zIndex: 50, // ensures it floats above container content
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      }}
    >
      <CloudOffline size={20} />
      <span>Offline</span>
    </div>
  );
}
